<table *ngFor="let item of staff" class="ir-plugin-table" style="margin-bottom: 10px">
  <tr *ngIf="item.Label">
    <td class="th-plugin-line--subheader">
      <span>
        <strong>{{ item.Label }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1 ir-installationreceived_comment"></span>
      </p>
    </td>
  </tr>
  <tr *ngIf="item.Type && item.Type >= 0">
    <td class="th-plugin-line--subheader">
      <span>
        <strong>{{ 'plugins.installationstaff.staff-type' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ item.Type | stafftype }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="item.Quantity">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationstaff.quantity' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ item.Quantity }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="hasValue(item)">
    <td class="plugin-table-cell">
      <span>
        <strong>
          {{ 'plugins.installationstaff.provenance' | translate }}
        </strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">
          {{ getProvenanceText(item) }}
        </span>
      </p>
    </td>
  </tr>
  <tr>
    <td class="plugin-table-cell">
      <span>
        <strong>
          {{ 'plugins.installationstaff.comment' | translate }}
        </strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p class="ir-pv3">
        <span
          class="ir-ph1 ir-installationreceived_comment"
          style="white-space: break-spaces"
          [innerHtml]="item.Comment"
        ></span>
      </p>
    </td>
  </tr>
</table>
